module.exports = __webpack_public_path__ + "static/media/team.e62c0311.png";